import React from 'react';

function SectionTitle({
  children,
  color
}) {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-10 col-md-offset-1 col-sm-12 text-center">
          <span className="bold ls1" style={{ color }}>
            {children}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/components/SectionTitle/index.js